import "./set-public-path";
import React from "react";
import ReactDOMClient from "react-dom/client";
import singleSpaReact from "single-spa-react";
import singleSpaCanopy from "single-spa-canopy";

const featureToggles = [];

const canopyLifecycles = singleSpaCanopy({
  domElementGetter,
  featureToggles,
  position: "absolute",
  hotload: {
    module,
    __webpack_require__: typeof __webpack_require__ !== "undefined" ? __webpack_require__ : null,
    dev: {
      enabled: false,
    },
  },
});

const reactLifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  loadRootComponent: () =>
    import(/* webpackChunkName: 'login-app' */ "./routes.component.js").then((mod) => mod.default),
  domElementGetter,
});

export let NavContent = null;

export const bootstrap = [
  canopyLifecycles.bootstrap,
  reactLifecycles.bootstrap,
  () => {
    return SystemJS.import("primary-navbar!sofe").then((primaryNavbar) => {
      NavContent = primaryNavbar.NavContent;
    });
  },
];

export const mount = [reactLifecycles.mount, canopyLifecycles.mount];

export const unmount = [reactLifecycles.unmount, canopyLifecycles.unmount];

export const unload = [canopyLifecycles.unload];

const mobileReactLifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  loadRootComponent: () =>
    import(/* webpackChunkName: 'mobile-login' */ "./mobile/root.component.js").then((mod) => mod.default),
  domElementGetter,
});

export const mobileLifecycles = {
  bootstrap: [canopyLifecycles.bootstrap, mobileReactLifecycles.bootstrap],
  mount: [mobileReactLifecycles.mount, canopyLifecycles.mount],
  unmount: [mobileReactLifecycles.unmount, canopyLifecycles.unmount],
  unload: [canopyLifecycles.unload],
};

function domElementGetter() {
  let el = document.getElementById("login-ui");
  if (!el) {
    el = document.createElement("div");
    el.setAttribute("id", "login-ui");
    el.style.top = "0px";
    document.body.appendChild(el);
  }

  return el;
}

export const mobileResponsiveBasePath = "/m/clients";

// exported for client-portal which supports switching tenant accounts
export { useSwitchUser } from "./select-user/use-switch-user";
